import APIV5 from '~/models/api';
import folderIcon from '~/images/icons/folder.png';

export default class ListItemNameController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} NodeService
	 * @param {any} Notification
	 */
	constructor(
		$element,
		$scope,
		$timeout,
		$translate,
		NodeService,
		Notification,
	) {
		this.$element = $element;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.NodeService = NodeService;
		this.Notification = Notification;

		/** @type {?import('tabulator-tables').CellComponent} */
		this.cell = null;

		/** @type {?import('../results/list-results.controller').RowDataItem} */
		this.item = null;

		/** @type {string} */
		this.name = '';

		/** @type {string} */
		this.suffix = '';

		/** @type {string} */
		this.oldName = '';

		/** @type {?Function} */
		this.onDownload = null;

		this.childsLoading = false;
	}

	/**
	 * @param {Event} event
	 */
	download(event) {
		if (this.onDownload) {
			this.onDownload({
				$event: event,
				$item: this.item,
			});
		}
	}

	updateRow() {
		this.row?.update({
			childsLoading: this.childsLoading,
			childsLoaded: this.childsLoaded,
			isExpanded: this.isExpanded,
		});
	}

	showExpandButtons() {
		return this.item?.child ?? true; // show by default if not specified
	}

	/**
	 * @param {Event} event
	 */
	collapse(event) {
		event.preventDefault();
		event.stopPropagation();

		if (!this.cell) {
			console.error('cell not found. Aborting');
			return;
		}

		this.isExpanded = false;
		this.updateRow();
		this.row?.treeCollapse();
	}

	/**
	 * @param {?Event} event
	 */
	async expand(event) {
		// console.log('expand', event);
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		if (!this.cell) {
			console.error('cell not found. Aborting');
			return;
		}

		if (!this.row) {
			console.error('row not found. Aborting');
			return;
		}

		if (this.childsLoaded === false) {
			this.$timeout(() => {
				this.childsLoading = true;
				this.updateRow();
			});

			if (this.item?.genre === 'object') {
				const response = await APIV5.instance.groupAround({
					root_kid: this.item.kid,
					blocs: {
						down: {
							type: 'down',
							conditions: [
								{
									relation_kid: 'K_NODE;COMPOSED_OF',
								},
							],
						},
					},
				}, { id: 'list-item-name.expand' });

				const downBlock = response.result.blocs.down;
				const { dico } = response;

				this.table?.blockRedraw();
				for (const item of downBlock) {
					const element = dico[item.kid];
					this.row.addTreeChild({
						kid: element.kid,
						isa: element.isa,
						isaname: ' ',
						item_count: item.count,
						name: `${element.name} (${item.count})`,
						name_type_kid: element.name_type_kid,
						datecreation: '',
						genre: 'group',
						// icon: 'folder',
						thumb_icon: folderIcon,
						thumb_raw: true,
						child: item.count > 0, // item.child,
					});
				}
				this.table?.restoreRedraw();
			}
			else {
				await this.expandRows();
			}
		}

		this.$timeout(() => {
			this.childsLoading = false;
			this.childsLoaded = true;
			this.isExpanded = true;

			this.updateRow();
			this.row?.treeExpand();
		});
	}

	/**
	 * @param {number} [packetIndex]
	 * @param {number} [total]
	 */
	async expandRows(packetIndex = 1, total = undefined) {
		if (!this.parent) {
			console.error('parent not found. Aborting');
			return;
		}

		if (!this.item?.kid) {
			return
		}

		const data = this.parent.getData();

		const response = await APIV5.instance.objectToMe({
			node_kid: data.kid,
			filter: [
				{ objnum_isa: this.item.kid },
			],
			packet_index: packetIndex,
		}, { id: 'list-item-name.expand' });

		const {
			nodes,
			index,
			size,
			nb,
		} = response;

		if (nb !== undefined) {
			// eslint-disable-next-line no-param-reassign
			total = nb;
		}

		await this.row?.update({
			child: nodes.length > 0,
		});

		this.table?.blockRedraw();
		for (const row of nodes) {
			const datecreation = row.datecreation === 'INFINITE'
				? Number.POSITIVE_INFINITY
				: (row.datecreation === '-INFINITE' ? Number.NEGATIVE_INFINITY : new Date(row.datecreation));

			this.row?.addTreeChild({
				...row,
				datecreation,
				isaname: row.isa_name,
				genre: 'object',
			});
		}

		if (total !== undefined && total >= size + index) {
			this.row?.addTreeChild({
				child: false,
				name:  this.$translate.instant('list.load-more'),
				kid:   'load-more',
				event: {
					click: async (/** @type {UIEvent} */ event) => {
						event.preventDefault();
						const rowData = this.row?.getData();
						const indexLoadMore = rowData.children.findIndex((/** @type {any} */ child) => child.kid === 'load-more');
						if (indexLoadMore >= 0) {
							rowData.children.splice(indexLoadMore, 1);
						}
						this.row?.update(rowData);
						await this.expandRows(size + index, total);

						this.$timeout(() => {
							this.childsLoading = false;
							this.childsLoaded = true;
							this.isExpanded = true;

							this.updateRow();
							this.row?.treeExpand();
						});
					},
				},
			});
		}

		this.table?.restoreRedraw();
	}

	/**
	 * @returns {string}
	 */
	getThumb() {
		let returnValue = '';
		if (this.item && 'thumb_icon' in this.item && this.item.thumb_icon) {
			returnValue = this.item.thumb_raw
				? this.item.thumb_icon
				: `data:${this.item.thumb_mimetype || 'image/png'};base64,${this.item.thumb_icon}`;
		}
		return returnValue;
	}

	/**
	 * @param {MouseEvent} event
	 */
	preventDefault(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
	}

	/**
	 * @param {KeyboardEvent} event
	 * @returns {Promise<any>}
	 */
	async renameItem(event) {
		if (this.item?.kid && ((event.type === 'keyup' && event.key === 'Enter') || event.type === 'blur')) {
			if (
				(
					(this.item.info.name?.value ?? '') !== this.name.trim()
					|| (this.item.info.suffix?.value ?? '') !== this.suffix.trim()
				)
				&& !this.item.loading
			) {
				try {
					this.item.loading = true;
					const nodeRenameSet = {
						node_kid: this.item.kid,
						name:     { ...this.item.info.name },
						suffix:   { ...this.item.info.suffix },
					};

					if (this.item.info.nameprefix?.defined) {
						nodeRenameSet.suffix.value = this.suffix?.trim() ?? null;
					}
					else {
						nodeRenameSet.name.value = this.name?.trim() ?? null;
					}

					const nodeRenameSetResult = await APIV5.instance.nodeRenameSet(
						nodeRenameSet,
						{ id: 'list-item-name.rename-item' },
					);
					this.item.name = nodeRenameSetResult.name?.value ?? '';

					this.Notification.info({
						title: this.$translate.instant('object.successfully-updated-title'),
						message: this.$translate.instant('object.successfully-updated-message'),
					});

					this.item.rename = false;
					this.item.loading = false;
					this.$timeout(() => {
						this.cell?.setValue(this.item?.name ?? '');
						this.$scope.$apply();
					});
				}
				catch (error) {
					console.error(error);
					this.item.name = this.oldName;
					this.item.rename = false;
				}
			}
			else {
				this.item.name = this.oldName;
				this.item.rename = false;
			}
		}
		return this.item;
	}

	$onInit() {
		this.$timeout(() => {
			this.$scope.$apply();
		});
		this.row = this.cell?.getRow();
		this.parent = this.row?.getTreeParent();
		const item = this.row?.getData();

		if (item.file === 1) {
			item.files = [{
				mimetype: item.mimetype,
				name: {
					node: item.name,
				},
				size: item.file_size,
				thumb: {
					icon: item.thumb_icon,
					mimetype: item.thumb_mimetype,
				},
				viewer: {
					mimetype: item.viewer_mimetype,
				},
			}];
		}

		this.item = item;
		this.table = this.row?.getTable();

		if (!this.isExpanded && this.item?.genre === 'group' && this.item.item_count === 1) {
			this.$timeout(async () => this.expand(null));
		}

		this.$scope.$watch('$ctrl.item.rename', (/** @type {boolean} */ renameFlag) => {
			if (this.item && renameFlag) {
				this.name = this.item.info.name?.value ?? '';
				this.suffix = this.item.info.suffix?.value ?? '';
				this.oldName = this.item.name;
				this.$timeout(() => {
					this.$element.find('input').trigger('focus');
				});
			}
		});
	}
}
